<template>
  <header class="my-header">
    <div class="cover">
      <img :src="cover" alt="cover" v-if="cover" />
    </div>
    <div class="content">
      <h4 class="title">{{ className }}</h4>
      <p class="common-font duty">职务：{{ duty }}</p>
      <p class="common-font eight">
        <template v-if="dateRange && dateRange.begDate">
          {{ dateRange.begDate }}~{{ dateRange.endDate }}
        </template>
      </p>
      <p class="common-font eight">所属课程：{{ courseName }}</p>
      <div class="link-btn">
        <img
          src="@/assets/clockin_icon_switch@2x.png"
          alt="button"
          class="img-btn"
          @click="jumpPage"
        />
        <span @click="jumpPage">切换班级</span>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    cover: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: '',
    },
    duty: {
      type: String,
      default: '',
    },
    dateRange: {
      default() {
        return {
          begDate: '2021.06.01',
          endDate: '2021.07.01',
        };
      },
    },
    courseName: {
      type: String,
      default: '',
    },
  },
  methods: {
    jumpPage() {
      this.$router.push('/admin-class-list');
    },
  },
};
</script>

<style lang="stylus" scoped>
.my-header {
  position: relative;
  display: flex;
  align-items: center;
  padding: 16px;
  background: #fff;

  .cover {
    width: 100px;
    height: 125px;
    background: #FFC650;
    border-radius: 6px;

    img {
      width: 100%;
      height 100%
      border-radius: 6px;
    }
  }

  .content {
    margin-left: 12px;
    width: calc(100% - 132px)

    .title {
      width 100%
      overflow: hidden;
      font-size: 20px;
      font-weight: 500;
      color: #191919;
      line-height: 20px;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break break-all
    }

    .common-font {
      width 100%
      overflow: hidden;
      font-size: 12px;
      color: #999;
      line-height: 12px;
      font-weight: 400;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break break-all
    }

    .duty {
      margin-top: 16px;
    }

    .eight {
      margin-top: 8px;
    }
  }

  .link-btn {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 13px;
    font-size: 12px;
    color: #5580AE;

    .img-btn {
      margin-left: 2px;
      width: 16px;
      height: 16px;
    }
  }
}
</style>
